import React from 'react';
import {BankStatementsLoadingDialog} from './BankStatementsLoadingDialog';
import {BankStatementsProvider} from '../context/BankStatementsContext';
import {BankStatementsCard} from './BankStatementsCard';

export function BankStatementsPage() {
  return (
    <BankStatementsProvider>
      <BankStatementsLoadingDialog/>
      <BankStatementsCard/>
    </BankStatementsProvider>
  );
}
